<template>
  <div>
	服务保障
  </div>
</template>

<script>
export default {
  name:"service"
}
</script>

<style>

</style>